export const asignarEncuestaFormModel = {
    formId: 'asignarEncuestaForm',
    formField: {
        deviceManagementId: {
            name: 'deviceManagementId',
            label: 'Dispositivo',
            requiredErrorMsg: 'El dispositivo es obligatorio'
        },
        surveyId: {
            name: 'surveyId',
            label: 'Encuestas',
            requiredErrorMsg: 'Debe seleccionar al menos una encuesta'
        }
    }
};
